import {
  Button,
  ContentArticle as ContentArticleMolecule,
  GenericError,
  Header,
  LoadingSpinner,
  Text,
} from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useCmsArticle } from './hooks/use-cms-article';

const ProfessionalReferralWelcome = ({
  orgCode,
  cmsContentId,
}: {
  readonly orgCode: string;
  readonly cmsContentId?: string;
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { article, fetching, errorMessage } = useCmsArticle(cmsContentId);

  if (fetching) return <LoadingSpinner />;
  if (errorMessage) return <GenericError titleKey="common.errors.notFound" />;
  if (cmsContentId && !article) return <GenericError />;

  return (
    <div className="mt-8 flex w-full justify-center">
      <div className="mx-[24px] flex w-full max-w-[327px] flex-col gap-6">
        {cmsContentId && article ? (
          <ContentArticleMolecule article={article} />
        ) : (
          <>
            <Header level="h1">{t('page.professionalReferral.welcome.header')}</Header>
            <Text>{t('page.professionalReferral.welcome.fallbackText')}</Text>
          </>
        )}
        <Button onClick={() => navigate(`/register?orgCode=${encodeURIComponent(orgCode)}`)}>
          {t('common.buttons.next')}
        </Button>
      </div>
    </div>
  );
};

export { ProfessionalReferralWelcome };
